<template >
  <div class="self-mask">
    <el-dialog
      :close-on-click-modal="false"
      title="文本文件预览"
      :visible.sync="showPreview"
      width="600px"
      center
      @close="handleClose"
    >
      <div class="txt-content">
        <div class="txt-dom" v-html="content"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "HzxmanageTxtPreview",

  data() {
    return {
      showPreview: false,
      content: null,
      url: null,
      loading: false,
    };
  },

  mounted() {
    if(this.content === null && this.url) {
      this.loadTxtContent()
    }
  },

  methods: {
    /* 获取文件内容 */
    loadTxtContent() {
      this.loading = true 
      fetch(this.url)
        .then((response) => {
          // 检查请求是否成功（状态码 200-299）
          if (!response.ok) {
            throw new Error(`请求失败，状态码: ${response.status}`);
          }
          // 将响应解析为文本（TXT 内容）
          return response.text();
        })
        .then((txtContent) => {
          // 成功获取 TXT 内容
          // console.log("TXT 内容：", txtContent);
          // 可在此处处理内容（如显示到页面）
          this.content = txtContent.replace(/\n/ig, "</br>");
        })
        .catch((error) => {
          this.loading = false 
          // 捕获错误（如网络问题、跨域限制等）
          console.error("读取失败：", error);
        });
    },
    init() {
      this.showPreview = true;
    },
    handleClose() {
      setTimeout(() => {
        this.$destroy(true);
        this.$el && this.$el.parentNode.removeChild(this.$el);
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.self-mask {
  position: fixed;
  z-index: 9999999999;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  background-color: rgba($color: #000000, $alpha: 0.5);
}
.txt-content {
  max-height: calc(80vh - 160px);
  min-height: 500px;
  overflow-y: auto;
  padding-right: 6px;
  @include scrollbar;
}
</style>
